import React,{ useEffect, useState } from 'react';
import ResellerNavbar from '../../../../components/ResellerNavbar';
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import './LandingPage.scss';
import isolation from '../../../../images/Isolation_Mode.svg';
import phonecall from '../../../../images/phone-call.svg';
import productbox from '../../../../images/box.svg';
import bankcard from '../../../../images/Bank Card.svg';
import customization from '../../../../images/customizationpaint.svg';
import electronic from '../../../../images/electronicproducts.svg';
import creators from '../../../../images/creators.svg';
import dot from '../../../../images/dots.svg';
import bgbrown from '../../../../images/Ellipse 2.svg';
import male from '../../../../images/mProperty 1=Variant2.png';
import female from '../../../../images/FProperty 1=Default.png';
import Footer from '../../../../components/Footer/Footer';
import { Link, useNavigate } from 'react-router-dom'; 

const LandingPage = () => {
    const [selectedOption, setSelectedOption] = useState('');
    const navigate=useNavigate();

    const handleOptionChange = (value) => {
      setSelectedOption(value);
    };
  
    
    const carouselSettings = {
        showThumbs: false,
        interval: 2000, 
        stopOnHover: true,
        showArrows: false,
      };
        const [faqItems, setFaqItems] = useState([
          { question: "How do I become a seller on your platform for electronics and customized products?", answer: "Becoming a seller is easy! Click on the 'Start selling' option, fill out the necessary details, and submit your application. Our team will review it, and upon approval, you can start showcasing your innovative electronics and customized products.", isOpen: false },
          { question: "Are there any restrictions on the types of electronics products I can sell?", answer: "Information about restrictions on the types of electronics products you can sell.", isOpen: false },
          { question: "Are there any fees associated with selling on your platform?", answer: "Information about fees associated with selling on the platform.", isOpen: false },
          { question: "What kind of customization options can I offer for my products?", answer: "Information about customization options for products.", isOpen: false },
        ]);
   
        const toggleFaqItem = (index) => {
          setFaqItems((prevItems) => {
            const updatedItems = [...prevItems];
            updatedItems[index].isOpen = !updatedItems[index].isOpen;
            return updatedItems;
          });
        };
      //   useEffect(() => {
      //     localStorage.removeItem("sellerregisterInfo");
      //     localStorage.removeItem("phoneNumber");
      // }, []);
  return (
    <div>
      <ResellerNavbar />
      <div className="start-container">
        <div className="containerone">
          <h2 className="start-content"z>Start Growing With Us</h2>
          <p className="start-contentP">
            Maximize sales in electronics & Customised products! Our platform is your gateway to showcase Premium gadgets and customized products. Join the revolution in retail today!
          </p>
        </div>
        <img src={isolation} alt="Isolation Mode" />
      </div>

      <div style={{display:'flex'}} className="features-container">
        <div className="features" style={{display: "flex"}}>
          <div style={{display:"flex",flexDirection:"row",gap:"20px"}} >
            <img  src={phonecall} alt="Phone Call" />
            <p>24x7 Seller Support</p>
          </div>
          <div  style={{display:"flex",flexDirection:"row",gap:"20px"}} >
            <img src={productbox} alt="Product Box" />
            <p>50+ products listed by us</p>
          </div>
          <div  style={{display:"flex",flexDirection:"row",gap:"20px"}} >
            <img src={bankcard} alt="Bank Card" />
            <p>7 Days regular payments</p>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="reasonlove">
          <h2 className="reasonto">
            Reasons to love <span style={{ color: '#3E8DE3' }}>Onstara</span>
          </h2>
        </div>

        <div className="feature-boxOne">
          <div>
            <img src={customization} alt="Customization"  className='featureimg' />
          </div>
          <div className="feature-content">
            <h3>Customization</h3>
            <p>
              Discover a realm of personalization at our marketplace. We specialize in selling customizable products that reflect your distinct style
            </p>
          </div>
        </div>

        <div className="feature-boxTwo">
          <div>
            <img src={electronic} alt="Electronic Products"  className='featureimg' />
          </div>
          <div className="feature-content">
            <h3>Electronic Products</h3>
            <p>
              Step into the future with our cutting-edge electronic products. From sleek gadgets to smart devices, we offer a curated selection to elevate your tech experience.
            </p>
          </div>
        </div>


        <div className="feature-boxThree">
          <div className="image-container">
            <img src={creators} alt="Creators"   className='featureimg'/>
          </div>
          <div className="text-content feature-content">
            <h3>Creators</h3>
            <p>
              Empower creators to shape their vision and sell personalized products on our platform. We offer a dynamic marketplace where innovation meets entrepreneurship.
            </p>
          </div>
      </div>   
        </div>
        <div className="container">

        <div className="Hearus">
         <h2 className="Hearusfrom">
          <span style={{ color: '#3E8DE3' }}>Hear Us From </span>Sellers
        </h2>
        </div>
        <div className="container">
        <div className='Hearusfromone'>  
        <Carousel {...carouselSettings}>
          <div>
            {/* <img src={female} alt="Female Seller" /> */}
            <div className='Hearusmale' >
                <div style={{display:'flex'}}>
                    <div>
                <img src={bgbrown} className='Hearusbgimg'/>
                </div><div style={{display:"flex", flexDirection:"column", alignItems:"flex-start"}}>
                    <h3 className='hearusmaleH3'>Anamika-Calicut</h3>
                    <p className='hearusmaleP'>Anamika, success showcases the power of marrying  craftsmanship with customisation,
making her store a go-to for bespoke adornments.</p>
</div>
                </div>
            </div>
          </div>

          <div>
            {/* <img src={female} alt="Female Seller" /> */}
            <div className='Hearusmale' >
                <div style={{display:'flex'}}>
                    <div>
                <img src={bgbrown} className='Hearusbgimg'/>
                </div><div style={{display:"flex", flexDirection:"column", alignItems:"flex-start"}}>
                    <h3 className='hearusmaleH3'>Anas - Kannur</h3>
                    <p className='hearusmaleP'>Anas, store became synonymous with innovation. High-quality products and strategic 
marketing turned ElectroTech into a profit powerhouse.</p>
</div>
                </div>
            </div>
          </div>
        
        </Carousel>
        </div>
        <div id="elementId">

      
        <div className="ask">
        <label>
          {/* <input
            type="radio"
            value="option1"
            checked={selectedOption === 'option1'}
            onChange={() => handleOptionChange('option1')}
          /> */}
                      <img src={dot} alt=" dot" />

          <span> </span>
          <span style={{ color: '#3E8DE3' }}>Frequently Asked Questions </span>
        </label>
      </div>
      </div>

      
        <p className="faq-subtitle">Want to ask something from us?</p>
      <div className='fullfaq'>
        <dl className="faq-list" >
          {faqItems.map((item, index) => (
            <div key={index}>
              <dt style={{display:'flex',margin:"30px"}}>
                <div className='Questions' >
                  {item.question}
                   </div>
                  <div className='faq-toggle'>
                    <span
                 
                  onClick={() => toggleFaqItem(index)}
                >{item.isOpen ? '-' : '+'}</span>
                  </div>
              </dt>
              {item.isOpen && <dd className="Ans">{item.answer}</dd>}
            </div>
          ))}
        </dl>
      </div>
    </div>
    <div  className="needHelp">
          
            <h3 className="Stillhelp">Still need help?</h3>
          <div style={{display:'flex'}}>
            <div  >
            <p className="needHelp-content" >Click on the blue round button at the bottom right corner of this page. You can also email our support team at <span style={{ color: '#3E8DE3' }}>support@onstara.com </span> </p>
          </div>
<div ><button onClick={()=>{navigate("/contactus")}} className='Contactus' >Contact us</button></div>
</div> </div>
        </div>
        <div className='Footer'>
            <Footer/>
        </div>
      </div>
  );
};
export default LandingPage;


 